var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"feature_product_area section_gap_bottom_custom"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},_vm._l((_vm.list.slice(0, 3)),function(item){return _c('Product',{key:item.id,attrs:{"product":item}})}),1),_vm._v(" "),_c('HowToUseText')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7050177d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductList.vue
// module id = null
// module chunks = 